import styled, { css } from "styled-components";
import { pageHeaderTransitionDuration } from "../../../../../settings";
import getBoxShadow from "../../../../../utils/getBoxShadow";
import getColor from "../../../../../utils/getColor";
import space from "../../../../../utils/space";
import transition from "../../../../../utils/transition";
import unit from "../../../../../utils/unit";
import { ToggleWrapper } from "../../../../atoms/ToggleWithLabelsAtm/ToggleWithLabelsAtm.styled";
import { zIndex } from "../settings";
import { containerBaseStyles } from "../styles";
export var bottomBarOrgBackgroundStyles = function bottomBarOrgBackgroundStyles(theme) {
  return css(["background-color:", ";box-shadow:", ";backdrop-filter:blur(", ");-webkit-backdrop-filter:blur(", ");"], getColor(theme, "backgroundLight", "hover"), getBoxShadow(theme, "nano"), space(3), space(3));
};
export var Wrapper = styled.div.withConfig({
  componentId: "sc-479r8p-0"
})(function (_ref) {
  var $isSticky = _ref.$isSticky,
    $isHeaderSticky = _ref.$isHeaderSticky,
    $headerMainHeight = _ref.$headerMainHeight,
    theme = _ref.theme;
  return css(["", ";position:static;left:0;width:100%;z-index:", ";&::before{max-width:100%;top:", ";}", " ", ""], containerBaseStyles(getColor(theme, "backgroundLight")), zIndex.headerBottomBar, $isHeaderSticky || $isSticky ? 0 : unit($headerMainHeight), $isSticky ? css(["position:fixed;top:0;&::before{z-index:-1;", ";max-width:none;}", "{background-color:transparent;box-shadow:none;}"], bottomBarOrgBackgroundStyles(theme), ToggleWrapper) : null, $isHeaderSticky ? css(["", ";transform:translateY(", ");"], transition("transform ".concat(pageHeaderTransitionDuration / 1000, "s")), unit($headerMainHeight)) : null);
});